import React, { useEffect } from "react";
import { FaCheckCircle, FaTimesCircle, FaTimes } from "react-icons/fa";

const Notification = ({ notification, onClose }) => {
  useEffect(() => {
    if (!notification) return;
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [notification]);

  if (!notification) return null;

  const styles = {
    success: {
      background: "#f0fdf4",
      border: "1px solid #bbf7d0",
      color: "#15803d",
      icon: <FaCheckCircle style={{ color: "#16a34a", fontSize: 15, flexShrink: 0 }} />,
    },
    error: {
      background: "#fff1f2",
      border: "1px solid #fecdd3",
      color: "#be123c",
      icon: <FaTimesCircle style={{ color: "#dc2626", fontSize: 15, flexShrink: 0 }} />,
    },
  };

  const s = styles[notification.type] || styles.success;

  return (
    <div style={{
      position: "fixed",
      top: 20,
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 100,
      display: "flex",
      alignItems: "center",
      gap: 10,
      padding: "12px 16px",
      borderRadius: 10,
      background: s.background,
      border: s.border,
      color: s.color,
      fontSize: 13,
      fontWeight: 500,
      boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
      whiteSpace: "nowrap",
      maxWidth: "calc(100vw - 32px)",
    }}>
      {s.icon}
      <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
        {notification.message}
      </span>
      <button
        onClick={onClose}
        style={{
          display: "flex", alignItems: "center", justifyContent: "center",
          width: 20, height: 20, borderRadius: "50%",
          border: "none", background: "transparent",
          color: s.color, cursor: "pointer", flexShrink: 0,
          opacity: 0.6, padding: 0,
        }}
      >
        <FaTimes style={{ fontSize: 11 }} />
      </button>
    </div>
  );
};

export default Notification;